import { TooltipButton } from '@bestseller-bit/frontend-community.components.tooltip-button';
import { styled } from '@mui/material/styles';

export const StyledDiscardButton = styled(TooltipButton)`
  height: 100%;
`;
